import type { ReportLevelSource } from '../../models/level.types'

function record(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null
}

function strings(value: unknown): string[] {
  if (!Array.isArray(value)) return []
  return [...new Set(value.filter((item): item is string => typeof item === 'string'))]
}

/** Validate the account bootstrap's intentionally feature-neutral `unknown[]` at module 08. */
export function normalizeReportLevelSources(value: unknown): ReportLevelSource[] {
  if (!Array.isArray(value)) return []
  return value.flatMap((candidate) => {
    const source = record(candidate)
    const data = record(source?.data)
    if (
      !source ||
      typeof source.level !== 'string' ||
      typeof source.partition_name !== 'string' ||
      typeof source.report_id !== 'number' ||
      !data
    ) {
      return []
    }
    return [
      {
        level: source.level,
        ...(typeof source.name_key === 'string' ? { name_key: source.name_key } : {}),
        partition_name: source.partition_name,
        report_id: source.report_id,
        data: {
          dimensions: strings(data.dimensions),
          metrics: strings(data.metrics),
          primary_fields: strings(data.primary_fields),
        },
      },
    ]
  })
}

export function normalizeWorkspaceLevelSources(
  value: Record<string, unknown[]> | null | undefined,
): Record<string, ReportLevelSource[]> {
  if (!value) return {}
  return Object.fromEntries(
    Object.entries(value).map(([workspaceId, levels]) => [
      workspaceId,
      normalizeReportLevelSources(levels),
    ]),
  )
}
